import React from 'react';
import Layout from '../components/Layout';
import BrandingList from '../components/BrandingList';

const Brandings = () => {
  return (
    <Layout>
      <BrandingList />
    </Layout>
  );
};

export default Brandings;
